export const versions = {
  version: "1.0.183",
  revision: "2618b430e",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-5034-g2618b430e-dirty",
    hash: "g2618b430e",
    distance: 5034,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "5034-g2618b430e-dirty",
    semverString: "1.0.183+5034.g2618b430e.dirty"
  }
};
